import React from 'react';
import { Row as RTRow } from 'react-table';

import { TableRow, TableCell, IconButton } from '@mui/material';


import { makeStyles } from 'tss-react/mui';
import { ArrowForwardIos } from '@mui/icons-material';


const useStyles = makeStyles()((theme) => ({
  cell: {
    paddingRight: 0,
    padding: theme.spacing(3, 2),
  },
  buttonCell: {
    padding: 0,
    paddingTop: 2,
    paddingBottom: 2,
    paddingRight: 2,
    textAlign: 'right',
    maxWidth: '40px',
    boxSizing: 'border-box',
  },
  tableRow: {
    background: theme.palette.common.white,
  },
  arrowIcon: {
    fontSize: 14,
  }
}));


export type MobileListRowProps = {
  row: RTRow<Record<string, unknown>>;
  className?: string;
  onClick?: () => void;
};


export const MobileListRow = ({ row, onClick, ...rowProps }: MobileListRowProps) => {
  const { classes, cx } = useStyles();

  return (
    <TableRow {...rowProps} className={cx(classes.tableRow, rowProps.className)} onClick={onClick}>
      {row.cells.map((cell) => {
        const { key, ...cellProps } = cell.getCellProps();

        return (
          <TableCell key={key} {...cellProps} className={classes.cell}>
            {cell.render('Cell')}
          </TableCell>
        );
      })}
      <TableCell className={classes.buttonCell}>
        <IconButton size="medium">
          <ArrowForwardIos className={classes.arrowIcon} />
        </IconButton>
      </TableCell>
    </TableRow>
  );
};
